import ScreenDimensions from '@utilities/screen-dimensions'

const JS_HOOK_LANGUAGE_SELECTOR = '[js-hook-language-selector]'
const JS_HOOK_BUTTON = '[js-hook-toggle]'
const JS_HOOK_BUTTON_LABEL = '[js-hook-button-label]'

class LanguageSelector {
  constructor(element) {
    this.element = element;
    this.languageSelector = [...document.querySelectorAll(JS_HOOK_LANGUAGE_SELECTOR)];

    this.removeTitle();
  }

  removeTitle() {
    if (ScreenDimensions.isTabletPortraitAndBigger) {
      Array.from(this.languageSelector).forEach((el) => {
        this.button = el.querySelector(JS_HOOK_BUTTON);
        this.title = this.button.querySelector(JS_HOOK_BUTTON_LABEL);
        this.text = this.title.innerText;
        this.newText = this.text.substring(this.text.indexOf(':') + 1);
        this.title.innerHTML = this.newText;
      })
    }
  }
}

export default LanguageSelector
